const revisions = new Map<string, number>();

export function getCustomColormapRevision(colormapId: string): number {
  return revisions.get(colormapId) ?? 0;
}

export function bumpCustomColormapRevision(colormapId: string): number {
  const next = (revisions.get(colormapId) ?? 0) + 1;
  revisions.set(colormapId, next);
  return next;
}

export function deleteCustomColormapRevision(colormapId: string): void {
  revisions.delete(colormapId);
}
